import { Button, Icon, MuiThemeProvider } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import type { StyledComponentProps } from '@material-ui/core/styles';
import PermissionHide from 'components/PermissionHide';
import Spin from 'components/Spin';
import { theme } from 'components/Theme';
import { agent, API_MAP } from 'helpers';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { listInvoiceItems, loadInvoice } from 'store/Orbita/Invoice/actions';
import InvoiceTags from 'v2/components/Shared/InvoiceTags';
import RefundInvoicePartnerButton from 'v2/components/Shared/RefundInvoicePartnerButton';

import type { ICanRefund } from 'v2/interfaces/shopping';

import AccessContent from './components/AccessContent';
import Affiliates from './components/Affiliates';
import Client from './components/Client';
import Cooproducer from './components/Cooproducer';
import Details from './components/Details';
import History from './components/History';
import Items from './components/Items';
import Payment from './components/Payment';
import Pins from './components/Pins';
import Tracking from './components/Tracking';
import Values from './components/Values';
import styles from './styles';

import type { DispatchProp } from 'react-redux';

interface IProps extends DispatchProp<any>, StyledComponentProps {
  invoice: any;
  items: any;
  access: any;
  user: any;
  match: any;
}

interface IStates {
  emailClient: string;
  refund: ICanRefund | null;
}

class InvoiceDetails extends React.Component<IProps, IStates> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      emailClient: null,
      refund: null,
    };
  }

  loadInvoice = () => {
    let params = this.props.match.params;

    if (params && params.invoiceId) {
      (async () => {
        try {
          await this.props.dispatch(loadInvoice(params.invoiceId));
          await this.props.dispatch(listInvoiceItems(params.invoiceId));

          this.setState({
            emailClient: this.props.invoice && this.props.invoice.customer.email ? this.props.invoice.customer.email : null,
          });
        } catch (error) {
          toast.error('Ops, ao carregar dados fatura');
        }
      })();
    }
  };

  loadCanRefund = () => {
    const invoiceId = this.props.match.params?.invoiceId;

    if (invoiceId) {
      agent.get(`${API_MAP.checkCanRefund}`.replace('{id}', invoiceId)).then((result) => {
        this.setState({ refund: result.data.data });
      });
    }
  };

  componentDidMount() {
    this.loadInvoice();
    this.loadCanRefund();
  }

  canSeeAccess = (invoice: any) => {
    if (!invoice.payment_status || invoice.payment_status.id !== 3) return false;
    const isProducer = !this.props.user.isFetching && invoice.product.producer_id === this.props.user.id;
    const isCoProducer = !this.props.user.isFetching && invoice.product.coproducer_id === this.props.user.id;

    return isProducer || isCoProducer;
  };

  render() {
    const { classes, invoice, items, access } = this.props;
    if (invoice.isFetching || (!invoice.id && !invoice.invoice_id)) {
      return (
        <div className='loading' style={{ height: '100%' }}>
          <Spin />
        </div>
      );
    } else {
      return (
        <MuiThemeProvider theme={theme}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={7} md={2}>
              <div className={classes.title}>
                <Link className={classes.hideOnPrint} to={'/producer/sales'}>
                  <Icon style={{ fontSize: 16, lineHeight: '21px' }}>chevron_left</Icon> Minhas vendas /
                </Link>

                <h2>
                  Fatura: <b>{invoice.id}</b>
                </h2>
              </div>
            </Grid>

            <Grid item xs={12} sm={5} md={10} className={classes.tagsContainer}>
              <InvoiceTags invoice={invoice} spacing={0} />
            </Grid>
          </Grid>

          <div className='m16'></div>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={8}>
              <Details classes={classes} invoice={invoice} items={items} />
              <div className='m24'></div>
              <Values classes={classes} invoice={invoice} items={items} />
              <div className='m24'></div>
              <Tracking classes={classes} invoice={invoice} />
              <div className='m24'></div>
              <Client classes={classes} invoice={invoice} email={this.state.emailClient} />
              <div className='m24'></div>
              <Payment classes={classes} invoice={invoice} />
              <div className='m24'></div>
              <Affiliates classes={classes} invoice={invoice} updateInvoice={this.loadInvoice} />
              <div className='m24'></div>
              <Cooproducer classes={classes} invoice={invoice} />
              <div className='m24'></div>
              <Items items={items} invoice={invoice} classes={classes} />
              {this.canSeeAccess(invoice) && (
                <>
                  <div className='m24'></div>
                  <AccessContent access={access} invoice={invoice} classes={classes} />
                </>
              )}
              <div className='m24'></div>

              <Pins invoice={invoice} classes={classes} />

              <div className='m24'></div>
              {!!this.state.refund && (
                <Grid item xs={12} md={12}>
                  <PermissionHide action='myeduzz:minhas-vendas:reembolsar'>
                    <RefundInvoicePartnerButton invoice={invoice} refund={this.state.refund} />
                  </PermissionHide>
                </Grid>
              )}
              <div className='m24'></div>
              <Grid item xs={12} md={3}>
                <Button className={classes.hideOnPrint} onClick={window.print} variant='outlined' fullWidth>
                  Imprimir <Icon>print</Icon>
                </Button>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={12} md={4}>
              <History invoice={invoice} classes={classes} />
            </Grid>
          </Grid>
        </MuiThemeProvider>
      );
    }
  }
}

function mapStateToProps(state: any) {
  return {
    invoice: state.orbita.Invoice.invoice,
    items: state.orbita.Invoice.items,
    access: state.orbita.Invoice.access,
    user: state.orbita.User.user,
  };
}

export default connect(mapStateToProps)(styles(InvoiceDetails));
